import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import icClose from '@iconify/icons-ic/twotone-close';

@Component({
  selector: 'vex-components-overview-dialogs',
  templateUrl: './components-overview-dialogs.component.html',
  styleUrls: ['./components-overview-dialogs.component.scss']
})
export class ComponentsOverviewDialogsComponent {

  result: string;

  dialogHTML =
    `<button mat-raised-button type="button" (click)="openDialog()" color="primary">Open Dialog</button>
<p *ngIf="result">You chose: {{ result }}</p>
`;

  constructor(private dialog: MatDialog) {
  }

  openDialog() {
    this.dialog.open(DemoDialogComponent, {
      disableClose: false,
      width: '400px'
    }).afterClosed().subscribe(result => {
      this.result = result;
    });
  }
}

@Component({
  selector: 'vex-components-overview-demo-dialog',
  template: `
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  </div>
      <mat-dialog-content>
          <p align="center">Your session has expired!<p>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
          <button mat-button color="primary" (click)="close('Yes')">OKAY</button>
      </mat-dialog-actions>
  `
})
export class DemoDialogComponent {

  icClose = icClose;

  constructor(private dialogRef: MatDialogRef<DemoDialogComponent>,
    private router: Router) {
  }

  close(answer: string) {
    this.dialogRef.close(answer);
    this.router.navigateByUrl('');
  }
}
